import { Col, Row } from 'antd'
import Select from 'components/Select'
import TreeSelect from 'components/TreeSelect'
import FilterChipComponent from 'components/UIComponents/FilterChipComponent'
import React, { useCallback, useEffect, useState } from 'react'
import Debounce from '../../../utils/Debounce'
import { FilterLabel } from '../../JobRoles/PageHeader/style'
import { filterFunction } from './CommonFunction'
import {
  ColsEnd,
  NoteDisplay,
  SpaceBetweenRow,
  StyledFilterCol,
  StyledFormItem,
  StyledPrimaryBtn,
} from './StyledComponent'

const requiredMessage =
  'Selection of <b>Domain</b> and <b> Batch year </b> are mandatory to load all graphs and data.'
const batchMessage =
  ' Selection of <b> Batch year </b> is mandatory to load all graphs and data.'
const domainMessage =
  ' Selection of <b> Domain </b>is mandatory to load all graphs and data.'
let selectAllStructure = [
  {
    title: 'Select All',
    value: 'all',
    children: [],
  },
]

export default function FilterComponent({
  stateList,
  state,
  getYear,
  setApiState,
  setState,
  apiState,
  getDepartmentList,
  instituteCampusId,
  setStateList,
  getDegreeList,
  getDomainList,
  getSpecializationList,
  handleClickLoadData,
  setFilteredDashboardDetails,
  loading,
  yearData,
  setYearData,
  filteredDashboardDetails,
}) {
  const [showModal, setShowModal] = useState(false)

  const [deparmentIds, setDepartmentIds] = useState([])

  const filterArr = filterFunction(state.selectedCourses)
  const selectedDomainLabel = state?.selectedDomain
    ?.map(item => item?.label)
    ?.join(', ')

  const initialCheck =
    state?.selectedDomain.length === 0 && !state?.selectedPassingYear?.year
  const selectedDomainMessage = `
  Great! You have selected the entire
  ${
    state.selectedDomain?.length === 1
      ? ` <b style="text-transform: capitalize;"> ${selectedDomainLabel} Domain. </b>`
      : `  <b style="text-transform: capitalize;"> ${selectedDomainLabel} Domains. </b>`
  }
`

  let message

  if (initialCheck) {
    message = requiredMessage
  } else if (state?.selectedDomain.length === 0) {
    message = domainMessage
  } else if (state?.selectedPassingYear == '') {
    message = `${selectedDomainMessage} ${batchMessage}`
  } else {
    message = ''
  }
  const handleShowFilterClick = () => {
    if (showModal) {
      setShowModal(false)
    } else {
      setShowModal(true)
    }
  }

  useEffect(() => {
    if (filterArr?.length === 0) {
      setShowModal(false)
    }
  }, [filterArr])
  const handleDomainChange = (value, label, extra) => {
    const selectedNodeProps = extra.triggerNode.props
    const idArr = value.map(item => item.value)
    const idJoin = idArr.join(',')

    // Update API state
    setApiState(prevState => ({
      ...prevState,
      domainId: idJoin,
      degreeId: value.length === 0 ? '' : prevState?.degreeId,
      departmentId: value.length === 0 ? '' : prevState?.departmentId,
      degreeType: value.length === 0 ? '' : prevState?.degreeType,
    }))

    // Fetch degrees for the updated domains
    fetchDegreeList({ domain: idJoin, jobCategory: state?.selectedCategory })

    // Update selectedCourses to match the current domains in `value`
    let updatedCourses = value.map(domain => ({
      domain: domain.label, // Use the label property from `value`
      domainValue: domain.value, // Use the value property from `value`
      degree: state.selectedCourses?.find(i => i?.domainValue === domain?.value)
        ?.degree,
    }))

    // Handle "all" selection case
    if (selectedNodeProps?.value === 'all') {
      const allDomains = selectedNodeProps?.children.map(item => ({
        domain: item.props.title,
        domainValue: item.props.value,
      }))

      const alreadySelected = state?.selectedCourses?.filter(domain =>
        allDomains.some(d => d?.domainValue === domain?.domainValue)
      )

      updatedCourses = [...allDomains]
      const v = updatedCourses?.filter(
        i => !alreadySelected?.some(d => d?.domainValue === i?.domainValue)
      )
      updatedCourses = [...alreadySelected, ...v]
    }

    // Remove duplicates in updatedCourses
    updatedCourses = updatedCourses.reduce((acc, current) => {
      const exists = acc.find(item => item.domainValue === current.domainValue)
      if (!exists) acc.push(current)
      return acc
    }, [])

    // Update selected degrees to match the updatedCourses
    const newSelectedDegree = state.selectedDegree.filter(degree =>
      updatedCourses.some(course =>
        course.degree?.some(d => d.degreeValue === degree)
      )
    )

    // Update departments based on selected domains
    const updatedDepartment = state.selectedDepartment.filter(item => {
      const parts = item?.split(' ')
      if (parts.length !== 3) return false
      const domainId = parts[2]
      return value.some(domain => domain.value === domainId)
    })

    // Update specializations based on selected domains
    const updatedSpecialization = state.selectedSpecialization.filter(item => {
      const parts = item?.split(' ')
      if (parts.length !== 4) return false
      const domainId = parts[2]
      return value.some(domain => domain.value === domainId)
    })

    // Update the main state with the new values
    setState(prevState => ({
      ...prevState,
      selectedDomain: value,
      selectedDegree: value.length === 0 ? [] : newSelectedDegree,
      selectedDepartment: value.length === 0 ? [] : updatedDepartment,
      selectedSpecialization: value.length === 0 ? [] : updatedSpecialization,
      selectedCourses: updatedCourses,
      isLoadData: false,
    }))

    // Reset filtered dashboard details
    setFilteredDashboardDetails({})
  }

  const handleDegreeChange = (value, label, extra) => {
    const selectedNodeProps = extra.triggerNode.props
    const idArr = state.selectedDomain.map(item => item.value)
    const idDomainJoin = idArr.join(',')
    const valueFilter = value.filter(item => item !== '')
    const idJoin = valueFilter.join(',')
    const getData = stateList.degreeList[0]?.children
      .map(item =>
        item?.children.map(type => {
          if (value?.includes(type.value)) return type.type
        })
      )
      .flat()
      .filter(item => item !== undefined)
    setApiState(prevState => ({
      ...prevState,
      domainId: idDomainJoin,
      degreeType: getData?.join(','),
      degreeId: idJoin,
      departmentId: value?.length === 0 ? '' : prevState?.departmentId,
    }))
    fetchDepartmentList(idDomainJoin, idJoin, '', state.selectedCategory)

    let selectedCourses = []

    const existedFilter =
      state.selectedDegree &&
      state.selectedCourses?.some(item =>
        state.selectedDegree?.includes(item?.degreeValue)
      )
    let updatedDepartment = [...(state?.selectedDepartment || [])]

    if (selectedNodeProps.value === 'all') {
      const all = selectedNodeProps.children.map(item => {
        const selectedDomainDegree = item.props.children.map(data => {
          return {
            domain: data.props.domain,
            domainValue: data.props.domainValue,
            degree: data.props.title,
            degreeValue: data.props.value,
          }
        })
        return selectedDomainDegree
      })
      const mergedArray = [].concat(...all)
      const removeAll = state.selectedCourses.map(item => {
        const v = mergedArray.filter(
          data => data.domainValue === item.domainValue
        )

        return {
          ...item,
          degree: v,
        }
      })

      selectedCourses = removeAll
    } else {
      if (existedFilter) {
        const filteredCourses = state.selectedCourses.filter(
          item => !state?.selectedDegree?.includes(item.degreeValue)
        )
        selectedCourses = filteredCourses
      } else {
        if (selectedNodeProps.text === 'degree') {
          let selectedCurrentObj = {
            domain: selectedNodeProps.domain,
            domainValue: selectedNodeProps.domainValue,
            degree: selectedNodeProps.title,
            degreeValue: selectedNodeProps.value,
          }

          const selectedArr = state.selectedCourses.map(item => {
            if (item.domainValue === selectedNodeProps.domainValue) {
              const existingObjRemove = Array.isArray(item.degree)
                ? item.degree
                : []
              const updatedDegree = existingObjRemove.filter(
                degreeItem => degreeItem.degreeValue !== selectedNodeProps.value
              )

              const isExist = existingObjRemove.some(
                degreeItem =>
                  degreeItem?.degreeValue === selectedNodeProps.value
              )
              if (isExist) {
                return {
                  ...item,
                  degree: updatedDegree,
                }
              } else {
                return {
                  ...item,
                  degree: [...existingObjRemove, selectedCurrentObj],
                }
              }
            } else {
              const degreeArr = item?.degree ? item.degree : []
              return {
                ...item,
                degree: [...degreeArr],
              }
            }
          })

          selectedCourses = selectedArr
        } else {
          const selectedChild = selectedNodeProps.children.map(data => {
            return {
              domain: data.props.domain,
              domainValue: data.props.domainValue,
              degree: data.props.title,
              degreeValue: data.props.value,
            }
          })
          const selectedArr = state.selectedCourses.map(item => {
            const degree =
              selectedNodeProps.value === item.domainValue
                ? selectedChild
                : item.degree
            return {
              ...item,
              degree: degree ? degree : [],
            }
          })

          selectedCourses = selectedArr
        }
      }
    }
    if (state?.selectedDegree?.length > value.length) {
      updatedDepartment = state.selectedDepartment?.filter(item => {
        let parts = item?.split(' ')
        if (parts.length !== 3) {
          return false
        }
        let domainId = parts[2]
        let degreeId = parts[0]

        if (
          selectedNodeProps?.value === domainId &&
          selectedNodeProps?.text == 'domain'
        ) {
          return false
        }
        if (
          selectedNodeProps?.value === degreeId &&
          selectedNodeProps?.text == 'degree'
        ) {
          return false
        }
        return true
      })
    }

    let updatedSpecialization = [...state.selectedSpecialization]

    updatedSpecialization = state.selectedSpecialization?.filter(item => {
      let parts = item?.split(' ')
      if (parts.length !== 4) {
        return false
      }
      let domainId = parts[2]
      if (selectedNodeProps?.value === domainId) {
        return false
      }
      let degreeId = parts[0]

      if (selectedNodeProps?.value === degreeId) {
        return false
      }
      return true
    })

    setState(prevState => ({
      ...prevState,
      selectedDegree: value,
      selectedCourses: selectedCourses,
      selectedDepartment: value.length === 0 ? [] : updatedDepartment,
      selectedSpecialization: value.length === 0 ? [] : updatedSpecialization,
      isLoadData: false,
    }))
    setFilteredDashboardDetails({})
  }

  const handleDepartmentChange = (value, label, extra) => {
    const selectedNodeProps = extra.triggerNode.props

    let selectedCourses = []
    if (selectedNodeProps.value === 'all') {
      const allChildren = selectedNodeProps.children.map(item => {
        const children = item.props.children.map(data => {
          const departChildren = data.props.children.map(depart => {
            return {
              ...depart.props,
            }
          })
          let degreeObj = {
            ...data.props,
            department: departChildren,
            degree: data.props.title,
            degreeValue: data.props.value,
          }

          return {
            ...degreeObj,
          }
        })
        let domainObj = {
          ...item.props,
          degree: children,
          domain: item.props.title,
          domainValue: item.props.value,
        }
        return {
          ...domainObj,
        }
      })
      const selected = state.selectedCourses.map(item => {
        const child = allChildren.find(
          data => data.domainValue === item.domainValue
        )
        if (child) {
          let degreeList
          if (child?.degree?.length === item?.degree?.length) {
            degreeList = item.degree.map((degreeItem, index) => {
              return {
                ...degreeItem,
                department: child.degree[index].department,
              }
            })
          } else {
            degreeList = item.degree.map(degreeItem => {
              return {
                ...degreeItem,
                department: [],
              }
            })
          }
          return {
            ...item,
            degree: degreeList,
          }
        } else {
          let removeDepartment = []
          if (allChildren.length === 0) {
            removeDepartment = item.degree.map(degree => {
              return {
                ...degree,
                department: [],
              }
            })
          }
          let uncheckAll = {
            ...item,
            degree: removeDepartment,
          }
          return allChildren.length === 0 ? uncheckAll : item
        }
      })
      selectedCourses = selected
    } else {
      if (selectedNodeProps.text === 'domain') {
        const degreeList = selectedNodeProps.children.map(item => {
          const departList = item.props.children
          const departmentList = departList.map(data => {
            return {
              ...data.props,
            }
          })
          return {
            ...item.props,
            degree: item.props.title,
            degreeValue: item.props.value,
            department: departmentList,
          }
        })
        const selectedDomainObj = {
          ...selectedNodeProps,
          domain: selectedNodeProps.title,
          domainValue: selectedNodeProps.value,
          degree: degreeList,
        }
        const selected = state.selectedCourses.map(item => {
          if (item.domainValue === selectedNodeProps.value) {
            let selectedDegree = []
            if (degreeList.length === 0) {
              selectedDegree = item.degree.map(degreeOb => {
                return {
                  ...degreeOb,
                  department: [],
                }
              })
            }
            let currentDegreeList = {
              ...selectedDomainObj,
              degree: selectedDegree,
            }
            return degreeList.length === 0
              ? currentDegreeList
              : selectedDomainObj
          } else {
            return item
          }
        })
        selectedCourses = selected
      } else if (selectedNodeProps.text === 'degree') {
        const degreeArray =
          selectedNodeProps.children.length > 0
            ? selectedNodeProps.children
            : []

        const departmentList = degreeArray.map(item => {
          return {
            ...item.props,
          }
        })
        const selected = state.selectedCourses.map(item => {
          if (item.domainValue === selectedNodeProps.domainValue) {
            if (item?.degree) {
              const findDegree = item.degree.find(
                data => data.degreeValue === selectedNodeProps.value
              )
              if (findDegree) {
                findDegree.department = departmentList || []
              }
            }
            return item
          } else {
            return item
          }
        })

        selectedCourses = selected
      } else {
        const selected = state.selectedCourses.map(item => {
          if (item.domainValue === selectedNodeProps.domainValue) {
            const findDegree = item.degree.map(data => {
              if (data.degreeValue === selectedNodeProps.degreeValue) {
                let departmentIdExists = false
                if (data?.department) {
                  departmentIdExists = data.department.some(
                    dep =>
                      dep.departmentValue === selectedNodeProps.departmentValue
                  )
                }

                const departmentObj = {
                  ...selectedNodeProps,
                }
                let department = []
                if (departmentIdExists) {
                  department = data.department.filter(
                    item =>
                      item.departmentValue !== selectedNodeProps.departmentValue
                  )
                } else {
                  department = data.department
                    ? [...data.department, departmentObj]
                    : [departmentObj]
                }
                return {
                  ...data,
                  department: department,
                }
              } else {
                return data
              }
            })
            return {
              ...item,
              degree: findDegree,
            }
          } else {
            return item
          }
        })
        selectedCourses = selected
      }
    }
    const idArr = state.selectedDomain.map(item => item.value)
    const idDomainJoin = idArr.join(',')
    const degreeIdArr = state.selectedDegree.map(item => item)
    const idDegreeJoin = degreeIdArr.join(',')

    const idSelectedArr = value
      .filter(item => item?.includes(' ') && item.split(' ')[0])
      .map(item => {
        const id = item.split(' ')
        return id[1]
      })
    const idDepartmentArr = idSelectedArr.join(',')
    setDepartmentIds(idDepartmentArr)
    setApiState(prevState => ({
      ...prevState,
      domainId: idDomainJoin,
      degreeId: idDegreeJoin,
      departmentId: idDepartmentArr,
    }))

    fetchSpecializationList(
      idDomainJoin,
      idDegreeJoin,
      idDepartmentArr,
      '',
      state.selectedCategory
    )

    let updatedSpecialization = [...state.selectedSpecialization]

    updatedSpecialization = state.selectedSpecialization?.filter(item => {
      let parts = item?.split(' ')
      if (parts.length !== 4) {
        return false
      }
      let domainId = parts[2]
      if (selectedNodeProps?.value === domainId) {
        return false
      }
      let degreeId = parts[0]

      if (selectedNodeProps?.value === degreeId) {
        return false
      }
      let departmentId = parts[1]

      if (selectedNodeProps?.departmentValue === departmentId) {
        return false
      }
      return true
    })

    setState(prevState => ({
      ...prevState,
      selectedDepartment: value,
      selectedSpecialization: value.length === 0 ? [] : updatedSpecialization,
      selectedCourses: selectedCourses,
      isLoadData: false,
    }))
    setFilteredDashboardDetails({})
  }

  const handleSpecializationChange = (value, label, extra) => {
    const selectedNodeProps = extra.triggerNode.props

    let selectedCourses = []
    if (selectedNodeProps.value === 'all') {
      const allChildren = selectedNodeProps.children.map(item => {
        const children = item.props.children.map(data => {
          const departChildren = data.props.children.map(depart => {
            const specChildren = depart.props.children.map(spec => {
              return {
                ...spec.props,
              }
            })
            let departObj = {
              ...depart.props,
              specialization: specChildren,
              department: depart.props.title,
              departmentValue: depart.props.departmentValue,
            }
            return { ...departObj }
          })

          let degreeObj = {
            ...data.props,
            department: departChildren,
            degree: data.props.title,
            degreeValue: data.props.degreeValue,
          }
          return { ...degreeObj }
        })

        let domainObj = {
          ...item.props,
          degree: children,
          domain: item.props.title,
          domainValue: item.props.value,
        }
        return { ...domainObj }
      })

      const selected = state.selectedCourses.map(item => {
        const child = allChildren.find(
          data => data.domainValue === item.domainValue
        )
        if (child) {
          let degreeList = item.degree.map((degreeItem, index) => {
            if (child.degree?.length === item?.degree?.length) {
              return {
                ...degreeItem,
                department: child.degree[index].department.map((dept, idx) => ({
                  ...dept,
                  specialization: dept.specialization || [],
                })),
              }
            } else {
              return {
                ...degreeItem,
                department: degreeItem?.department?.map(dept => ({
                  ...dept,
                  specialization: [],
                })),
              }
            }
          })
          return { ...item, degree: degreeList }
        } else {
          let removeDepartment = item.degree.map(degree => ({
            ...degree,
            department: degree?.department?.map(dept => ({
              ...dept,
              specialization: [],
            })),
          }))

          let uncheckAll = { ...item, degree: removeDepartment }
          return allChildren.length === 0 ? uncheckAll : item
        }
      })

      selectedCourses = selected
    } else if (selectedNodeProps.text === 'domain') {
      const degreeList = selectedNodeProps.children.map(item => {
        const departList = item.props.children
        const departmentList = departList.map(data => {
          const specList = data?.props?.children?.map(spec => {
            return {
              ...spec.props,
            }
          })
          return {
            ...data.props,
            specialization: specList,
          }
        })
        return {
          ...item.props,
          degree: item.props.title,
          degreeValue: item.props.value,
          department: departmentList,
        }
      })
      const selectedDomainObj = {
        ...selectedNodeProps,
        domain: selectedNodeProps.title,
        domainValue: selectedNodeProps.value,
        degree: degreeList,
      }

      const selected = state.selectedCourses.map(item => {
        if (item.domainValue === selectedNodeProps.value) {
          let selectedDegree = []
          if (degreeList.length === 0) {
            selectedDegree = item.degree.map(degreeOb => {
              return {
                ...degreeOb,
                department: [],
              }
            })
          }
          let currentDegreeList = {
            ...selectedDomainObj,
            degree: selectedDegree,
          }
          return degreeList.length === 0 ? currentDegreeList : selectedDomainObj
        } else {
          return item
        }
      })
      selectedCourses = selected
    } else if (selectedNodeProps.text === 'degree') {
      const degreeArray =
        selectedNodeProps.children.length > 0 ? selectedNodeProps.children : []
      const departmentList = degreeArray.map(item => {
        const specialization = item?.props?.children?.map(child => {
          const { children, ...rest } = child.props
          return { ...rest }
        })
        const { children, ...rest } = item.props
        return {
          ...rest,
          specialization: extra?.checked ? specialization : [],
        }
      })
      const selected = state.selectedCourses.map(item => {
        if (item.domainValue === selectedNodeProps.domainValue) {
          const findDegree = item?.degree?.map(degree => {
            if (degree?.degreeValue === selectedNodeProps?.value) {
              const removedSpec = degree?.department?.map(depart => {
                const { specialization, ...rest } = depart
                return {
                  ...rest,
                }
              })
              return {
                ...degree,
                department: extra?.checked ? departmentList : removedSpec,
              }
            }
            return degree
          })
          return {
            ...item,
            degree: findDegree,
          }
        }

        return item
      })
      selectedCourses = selected
    } else if (selectedNodeProps.text === 'depart') {
      const departmentArray =
        selectedNodeProps.children.length > 0 ? selectedNodeProps.children : []
      const specializationList = departmentArray.map(item => {
        return {
          ...item.props,
        }
      })
      const selected = state.selectedCourses.map(item => {
        if (item.domainValue === selectedNodeProps.domainValue) {
          const findDegree = item.degree.map(data => {
            if (data.degreeValue === selectedNodeProps.degreeValue) {
              const findDepartment = data?.department?.map(dept => {
                if (
                  dept?.departmentValue === selectedNodeProps?.departmentValue
                ) {
                  let specializationIdExists = false

                  if (dept?.specialization) {
                    specializationIdExists = dept.specialization.some(
                      spec =>
                        spec.specializationValue ===
                        selectedNodeProps.specializationValue
                    )
                  }

                  let specialization = []
                  if (specializationIdExists) {
                    specialization = dept.specialization.filter(
                      spec =>
                        spec.specializationValue !==
                        selectedNodeProps.specializationValue
                    )
                  } else {
                    specialization = specializationList
                  }

                  return {
                    ...dept,
                    specialization: specialization,
                  }
                }
                return dept
              })

              return {
                ...data,
                department: findDepartment,
              }
            }

            return data
          })

          return {
            ...item,
            degree: findDegree,
          }
        }

        return item
      })
      selectedCourses = selected
    } 
    else {
     
        const selected = state.selectedCourses.map(item => {
          if (item.domainValue === selectedNodeProps.domainValue) {
            const findDegree = item.degree.map(data => {
              if (data.degreeValue === selectedNodeProps.degreeValue) {
                const findDepartment = data?.department?.map(departItem => {
                  // Add departmentValue check here
                  if (
                    departItem?.degreeValue === selectedNodeProps?.degreeValue &&
                    departItem?.departmentValue === selectedNodeProps?.departmentValue
                  ) {
                    let specializationIdExists = false
      
                    if (departItem?.specialization) {
                      specializationIdExists = departItem.specialization.some(
                        spec =>
                          spec.specializationValue ===
                          selectedNodeProps.specializationValue
                      )
                    }
      
                    const specializationObj = { ...selectedNodeProps }
      
                    let specialization = []
                    if (specializationIdExists) {
                      specialization = departItem.specialization.filter(
                        item =>
                          item.specializationValue !==
                          selectedNodeProps.specializationValue
                      )
                    } else {
                      specialization = departItem.specialization
                        ? [...departItem.specialization, specializationObj]
                        : [specializationObj]
                    }
      
                    return {
                      ...departItem,
                      specialization: specialization,
                    }
                  }
                  return departItem
                })
                return {
                  ...data,
                  department: findDepartment,
                }
              }
              return data
            })
      
            return {
              ...item,
              degree: findDegree,
            }
          }
          return item
        })
        selectedCourses = selected
      
    }

    const idArr = state.selectedDomain.map(item => item.value)
    const idDomainJoin = idArr.join(',')
    const degreeIdArr = state.selectedDegree.map(item => item)
    const idDegreeJoin = degreeIdArr.join(',')
    const departIdArr = state.selectedDepartment.map(item => item)
    const idDepartJoin = departIdArr.join(',')

    setApiState(prevState => ({
      ...prevState,
      domainId: idDomainJoin,
      degreeId: idDegreeJoin,
      departmentId: idDepartJoin,
      // specializationId: idSpecArr,
    }))

    setState(prevState => ({
      ...prevState,
      selectedSpecialization: value,
      selectedCourses: selectedCourses,
      isLoadData: false,
    }))
    setFilteredDashboardDetails({})
  }

  const handleRemoveFilter = data => {
    const domainIndex = data?.indices?.domainIndex
    const degreeIndex = data?.indices?.degreeIndex
    const departmentIndex = data?.indices?.departmentIndex
    const specializationIndex = data?.indices?.specializationIndex
    let selectedCourses
    let removedDomain = [...state.selectedDomain]
    let removedDegree = [...state.selectedDegree]
    let removedDepartment = [...state.selectedDepartment]
    let removedSpecialization = [...state.selectedSpecialization]
    if (Object.keys(data?.indices).length == 1) {
      const selectedId = state.selectedCourses[domainIndex]
      selectedCourses = state.selectedCourses.filter(
        obj => obj.domainValue !== selectedId.domainValue
      )
      removedDomain = state.selectedDomain.filter(
        item => item.value !== selectedId.domainValue
      )
    } else if (Object.keys(data?.indices).length == 2) {
      const selectedId = state.selectedCourses[domainIndex]?.degree[degreeIndex]
      if (selectedId) {
        let selectedDegreeList = state?.selectedCourses[
          domainIndex
        ]?.degree?.filter(obj => obj.degreeValue !== selectedId.degreeValue)
        selectedCourses = state.selectedCourses.map(item => {
          if (
            item.domainValue === state.selectedCourses[domainIndex].domainValue
          ) {
            return {
              ...item,
              degree: selectedDegreeList,
            }
          } else {
            return item
          }
        })
      }
      removedDegree =
        state.selectedDegree?.length > 0 &&
        state.selectedDegree.filter(item => item !== selectedId.degreeValue)
      removedSpecialization = state?.selectedSpecialization?.filter(item => {
        if (typeof item !== 'string') {
          return false
        }
        let removedId = item.split(' ')[0]
        return removedId !== selectedId.degreeValue
      })
    } else if (Object.keys(data?.indices).length == 3) {
      const selectedId =
        state.selectedCourses[domainIndex]?.degree[degreeIndex]?.department[
          departmentIndex
        ]

      if (selectedId) {
        let selectedDepartmentList = state.selectedCourses[domainIndex].degree[
          degreeIndex
        ].department.filter(
          obj => obj.departmentValue !== selectedId.departmentValue
        )
        selectedCourses = state.selectedCourses.map(item => {
          if (item.domainValue === selectedId.domainValue) {
            const selectedDegree = item.degree.map(degree => {
              if (degree.degreeValue === selectedId.degreeValue) {
                return {
                  ...degree,
                  department: selectedDepartmentList,
                }
              } else {
                return degree
              }
            })
            return {
              ...item,
              degree: selectedDegree,
            }
          } else {
            return item
          }
        })
        removedDepartment = state?.selectedDepartment?.filter(
          item => item !== selectedId.value
        )
        removedSpecialization = state?.selectedSpecialization?.filter(item => {
          if (typeof item !== 'string') {
            return false
          }

          let ids = item.split(' ')
          let removedId = ids?.length === 4 ? ids.slice(0, -1) : ids
          return removedId.join(' ') !== selectedId.value
        })
      }
    } else if (Object.keys(data?.indices).length == 4) {
      const selectedId =
        state.selectedCourses[domainIndex]?.degree[degreeIndex]?.department[
          departmentIndex
        ]?.specialization[specializationIndex]

      if (selectedId) {
        let selectedSpecializationList = state.selectedCourses[
          domainIndex
        ]?.degree[degreeIndex]?.department[
          departmentIndex
        ].specialization.filter(
          obj => obj.specializationValue !== selectedId.specializationValue
        )

        selectedCourses = state.selectedCourses.map(item => {
          if (item.domainValue === selectedId.domainValue) {
            const selectedDegree = item.degree.map(degree => {
              if (degree.degreeValue === selectedId.degreeValue) {
                const selectedDepartment = degree?.department?.map(depart => {
                  if (depart.departmentValue == selectedId.departmentValue) {
                    return {
                      ...depart,
                      specialization: selectedSpecializationList,
                    }
                  } else {
                    return depart
                  }
                })
                return {
                  ...degree,
                  department: selectedDepartment,
                }
              } else {
                return degree
              }
            })
            return {
              ...item,
              degree: selectedDegree,
            }
          } else {
            return item
          }
        })

        removedSpecialization = state?.selectedSpecialization?.filter(
          item => item !== selectedId.value
        )
      }
    }
    const idArr = removedDomain.map(item => item.value)
    const idDomainJoin = idArr.join(',')
    const degreeIdArr = removedDegree.map(item => item)
    const idDegreeJoin = degreeIdArr.join(',')

    const getData = stateList.degreeList[0]?.children
      .map(item =>
        item?.children.map(type => {
          if (removedDegree?.includes(type.value)) return type.type
        })
      )
      .flat()
      .filter(item => item !== undefined)
    const idSelectedArr = removedDepartment.map(item => {
      const id = item.split(' ')
      return id[1]
    })
    const idDepartmentArr = idSelectedArr.join(',')
    const specIdArr = removedSpecialization.map(item => {
      const id = item.split(' ')
      return id[1]
    })
    const specialisationIdArr = specIdArr.join(',')
    setApiState(prevState => ({
      ...prevState,
      domainId: idDomainJoin,
      degreeId: idDegreeJoin,
      degreeType: getData?.join(','),
      departmentId: idDepartmentArr,
      specializationId: specialisationIdArr,
    }))
    setState(prevState => ({
      ...prevState,
      selectedCourses: selectedCourses,
      selectedDomain: removedDomain,
      selectedDegree: removedDegree,
      selectedDepartment: removedDepartment,
      isLoadData: false,
      selectedSpecialization: removedSpecialization,
    }))
    if (Object.keys(data?.indices).length == 1) {
      fetchDegreeList({
        domain: idDomainJoin,
        jobCategory: state?.selectedCategory,
      })
    } else if (Object.keys(data?.indices).length == 2) {
      fetchDepartmentList(
        idDomainJoin,
        idDegreeJoin,
        '',
        state.selectedCategory
      )
    } else if (Object.keys(data?.indices).length == 3) {
      fetchSpecializationList(
        idDomainJoin,
        idDegreeJoin,
        idDepartmentArr,
        '',
        state.selectedCategory
      )
    } else {
      //
    }
    setFilteredDashboardDetails({})
  }

  const handleDomainSearch = useCallback(
    Debounce(data => {
      fetchDomainList(data)
    }, 1000),
    [fetchDomainList, instituteCampusId]
  )

  const handleDegreeSearch = useCallback(
    Debounce(searchTerm => {
      if (apiState?.domainId) {
        fetchDegreeList({ domain: apiState?.domainId, search: searchTerm })
      }
    }, 1000),
    [apiState?.domainId, fetchDegreeList]
  )

  const handleDepartmentSearch = useCallback(
    Debounce(data => {
      if (apiState?.degreeId) {
        fetchDepartmentList(
          apiState?.domainId,
          apiState?.degreeId,
          data,
          state.selectedCategory
        )
      }
    }, 1000),
    [apiState?.degreeId, fetchDepartmentList]
  )

  const handleSpecializationSearch = useCallback(
    Debounce(data => {
      if (apiState?.departmentId) {
        fetchSpecializationList(
          apiState?.domainId,
          apiState?.degreeId,
          deparmentIds,
          data,
          state.selectedCategory
        )
      }
    }, 1000),
    [apiState?.departmentId, deparmentIds, fetchSpecializationList]
  )

  const fetchDepartmentList = useCallback(
    async (
      domain,
      degree,
      search = '',
      jobCategory = state?.selectedCategory
    ) => {
      try {
        let payLoad = {
          domainId: domain,
          degreeId: degree,
          jobCategory: jobCategory,
          search: search,
        }

        const response = await getDepartmentList(instituteCampusId, payLoad)
        if (response?.length) {
          const data = response.map(item => {
            let children = item.degree.map(data => {
              const departArr = data.degreeStreamMap.map(v => {
                return {
                  value: data.id + ' ' + v.stream.id + ' ' + item?.id,
                  title: v.stream.name,
                  degree: data.name,
                  degreeValue: data.id,
                  domain: item.name,
                  domainValue: item.id,
                  departmentValue: v.stream.id,
                  text: 'depart',
                  department: v.stream.name,
                }
              })
              return {
                value: data.id,
                title: data.name,
                domain: item.name,
                domainValue: item.id,
                children: departArr,
                text: 'degree',
              }
            })
            return {
              value: item.id,
              title: item.name?.toLowerCase(),
              children: children,
              text: 'domain',
            }
          })
          const departmentData = selectAllStructure.map(item => {
            return {
              ...item,
              children: data,
            }
          })
          setStateList(prevState => ({
            ...prevState,
            departmentList: departmentData,
          }))
        } else {
          setStateList(prevState => ({
            ...prevState,
            departmentList: [],
          }))
        }
        return response
      } catch (err) {
        //
      }
    },
    [instituteCampusId]
  )

  const fetchDegreeList = useCallback(
    async ({ domain, search = '', jobCategory = state.selectedCategory }) => {
      try {
        const domainId = domain ? domain : apiState.domainId
        const response = await getDegreeList(
          domainId,
          instituteCampusId,
          jobCategory,
          search
        )
        if (response?.length) {
          const data = response.map(item => {
            let children = item.degree.map(data => {
              return {
                value: data.id,
                title: data.name,
                domain: item.name,
                domainValue: item.id,
                text: 'degree',
                type: data.type,
              }
            })
            return {
              value: item.id,
              title: item.name?.toLowerCase(),
              children: children,
              text: 'domain',
            }
          })
          const degreeData = selectAllStructure.map(item => {
            return {
              ...item,
              children: data,
            }
          })

          setStateList(prevState => ({
            ...prevState,
            degreeList: degreeData,
          }))
          return data
        } else {
          setStateList(prevState => ({
            ...prevState,
            degreeList: [],
          }))
        }
      } catch (err) {
        //
      }
    },
    [instituteCampusId]
  )
  const fetchYearList = useCallback(async () => {
    const result = await getYear(instituteCampusId)
    setYearData(result)
  })
  const fetchDomainList = useCallback(
    async (search = '', jobCategory = state?.selectedCategory) => {
      try {
        const response = await getDomainList(
          instituteCampusId,
          jobCategory,
          search
        )
        if (response?.length) {
          const structure = response.map(item => ({
            title: item.name?.toLowerCase(),
            value: item.id,
          }))
          const domainData = selectAllStructure.map(item => ({
            ...item,
            children: structure,
          }))
          setStateList(prevState => ({
            ...prevState,
            domainList: domainData,
          }))
          return domainData
        } else {
          setStateList(prevState => ({
            ...prevState,
            domainList: [],
          }))
          return []
        }
      } catch (err) {
        console.error(err) // Handle the error appropriately
      }
    },
    [instituteCampusId, state?.selectedCategory, setStateList]
  )

  const fetchSpecializationList = useCallback(
    async (
      domain,
      degree,
      department,
      search = '',
      jobCategory = state?.selectedCategory
    ) => {
      try {
        let payLoad = {
          domainId: domain,
          degreeId: degree,
          ...(department.length !== 0 ? { streamId: department } : {}),
          jobCategory: jobCategory,
          search: search,
        }

        const response = await getSpecializationList(instituteCampusId, payLoad)

        if (response?.length) {
          const data = response.map(item => {
            let children = item.degrees.map(data => {
              const departArr = data.streams.map(v => {
                const streamArr = v.specializations.map(spec => {
                  return {
                    value:
                      data.id + ' ' + v.id + ' ' + item?.id + ' ' + spec.id,
                    title: spec.name,
                    degree: data.name,
                    degreeValue: data.id,
                    domain: item.name,
                    domainValue: item.id,
                    department: v.name,
                    departmentValue: v.id,
                    specialization: spec.name,
                    specializationValue: spec.id,
                    text: 'spec',
                  }
                })
                return {
                  value: data.id + ' ' + v.id + ' ' + item?.id,
                  title: v.name,
                  degree: data.name,
                  degreeValue: data.id,
                  domain: item.name,
                  domainValue: item.id,
                  departmentValue: v.id,
                  text: 'depart',
                  department: v.name,
                  children: streamArr,
                }
              })
              return {
                value: data.id,
                title: data.name,
                domain: item.name,
                domainValue: item.id,
                children: departArr,
                text: 'degree',
              }
            })
            return {
              value: item.id,
              title: item.name?.toLowerCase(),
              children: children,
              text: 'domain',
            }
          })
          const specializationData = selectAllStructure.map(item => {
            return {
              ...item,
              children: data,
            }
          })
          setStateList(prevState => ({
            ...prevState,
            specializationList: specializationData,
          }))
        } else {
          setStateList(prevState => ({
            ...prevState,
            specializationList: [],
          }))
        }
        return response
      } catch (err) {
        //
      }
    },
    [instituteCampusId]
  )

  const handleYearChange = (e, option) => {
    setState(prev => ({
      ...prev,
      selectedPassingYear: option?.option ? option?.option : '',
      isLoadData: false,
    }))
    setFilteredDashboardDetails({})
  }

  useEffect(() => {
    if (instituteCampusId) {
      fetchDomainList()
      fetchYearList()
    }
  }, [instituteCampusId])

  return (
    <>
      <SpaceBetweenRow gutter={60}>
        <StyledFilterCol md={4} xs={24}>
          <FilterLabel>Domain</FilterLabel>
          <StyledFormItem>
            <TreeSelect
              showArrow
              filterTreeNode={false}
              treeData={stateList.domainList || []}
              treeCheckable={true}
              placeholder="Select Domain"
              maxTagCount={state.selectedDomain?.length === 1 ? 1 : 0}
              maxTagPlaceholder={omittedValues => (
                <span>
                  <strong>{omittedValues?.length}+</strong> selected
                </span>
              )}
              showSearch={true}
              onChange={handleDomainChange}
              placeholderSize={'12px'}
              labelInValue
              shadowBox
              treeDefaultExpandAll={true}
              removeTreeIndent={true}
              onSearch={data => handleDomainSearch(data)}
              //height={'auto'}
              treeNodeFilterProp="title"
              autoClearSearchValue={false}
              value={state.selectedDomain}
              listHeight={180}
            />
          </StyledFormItem>
        </StyledFilterCol>
        <StyledFilterCol md={4} xs={24}>
          <FilterLabel>Degree</FilterLabel>
          <StyledFormItem>
            <TreeSelect
              showArrow
              filterTreeNode={false}
              treeData={stateList.degreeList || []}
              treeCheckable={true}
              placeholder="Select Degree"
              maxTagCount={state.selectedDegree?.length === 1 ? 1 : 0}
              maxTagPlaceholder={omittedValues => (
                <span>
                  <strong>{omittedValues?.length}+</strong> selected
                </span>
              )}
              showSearch={true}
              placeholderSize={'12px'}
              onChange={handleDegreeChange}
              treeDefaultExpandAll={true}
              removeTreeIndent={true}
              shadowBox
              disabled={state?.selectedDomain?.length === 0}
              onSearch={data => handleDegreeSearch(data)}
              // height={'auto'}
              treeNodeFilterProp="title"
              autoClearSearchValue={false}
              value={state.selectedDegree || []}
              listHeight={180}
            />
          </StyledFormItem>
        </StyledFilterCol>
        <StyledFilterCol md={4} xs={24}>
          <FilterLabel>Dept.</FilterLabel>
          <StyledFormItem>
            <TreeSelect
              showArrow
              filterTreeNode={false}
              treeData={stateList.departmentList || []}
              treeCheckable={true}
              placeholder="Select Dept."
              maxTagCount={state.selectedDepartment?.length === 1 ? 1 : 0}
              maxTagPlaceholder={omittedValues => (
                <span>
                  <strong>{omittedValues?.length}+</strong> selected
                </span>
              )}
              placeholderSize={'12px'}
              showSearch={true}
              onChange={handleDepartmentChange}
              treeDefaultExpandAll={true}
              removeTreeIndent={true}
              shadowBox
              disabled={state?.selectedDegree?.length === 0}
              onSearch={data => handleDepartmentSearch(data)}
              // height={'auto'}
              value={state.selectedDepartment || []}
              treeNodeFilterProp="title"
              autoClearSearchValue={false}
              listHeight={180}
            />
          </StyledFormItem>
        </StyledFilterCol>
        <StyledFilterCol md={4} xs={24}>
          <FilterLabel>Spec.</FilterLabel>
          <StyledFormItem>
            <TreeSelect
              showArrow
              filterTreeNode={false}
              treeData={stateList.specializationList || []}
              treeCheckable={true}
              placeholder="Select Spec."
              maxTagCount={state.selectedSpecialization?.length === 1 ? 1 : 0}
              maxTagPlaceholder={omittedValues => (
                <span>
                  <strong>{omittedValues?.length}+</strong> selected
                </span>
              )}
              placeholderSize={'12px'}
              showSearch={true}
              onChange={handleSpecializationChange}
              treeDefaultExpandAll={true}
              removeTreeIndent={true}
              shadowBox
              disabled={state?.selectedDepartment?.length === 0}
              onSearch={data => handleSpecializationSearch(data)}
              // height={'auto'}
              value={state.selectedSpecialization || []}
              treeNodeFilterProp="title"
              autoClearSearchValue={false}
              listHeight={180}
            />
          </StyledFormItem>
        </StyledFilterCol>
        {/* <StyledFilterCol md={4} xs={24}></StyledFilterCol> */}
        <StyledFilterCol md={8} xs={24}>
          <div
            style={{
              display: 'flex',
              width: '100%',
              alignItems: 'center',
              gap: 10,
              justifyContent: 'flex-end',
              //   data,
            }}
          >
            <FilterLabel whiteSpace="pre">Passing Year</FilterLabel>
            <StyledFormItem style={{ width: '180px', marginBottom: '15px' }}>
              <Select
                showSearch={true}
                allowClear={true}
                OptionData={yearData}
                placeholder="Select Passing Year"
                valueParam="year"
                nameParam="year"
                colorstyle={true}
                value={state?.selectedPassingYear?.year}
                onChange={handleYearChange}
                filterOption={(input, option) => {
                  const childrenString = option.children
                    .toString()
                    .toLowerCase()
                  return childrenString?.includes(input.toLowerCase())
                }}
                listHeight={180}
                boxShadow="rgba(123, 97, 255, 0.15) 0px 2px 6px 0px"
                selectedOptionColor={'#3249D7'}
              />
            </StyledFormItem>
          </div>
        </StyledFilterCol>
      </SpaceBetweenRow>
      {filterArr?.length > 0 && (
        <FilterChipComponent
          data={filterArr || []}
          handleClick={handleShowFilterClick}
          open={showModal}
          handleRemoveFilter={handleRemoveFilter}
        />
      )}
      <Row>
        <Col md={18}>
          {message ? (
            <NoteDisplay dangerouslySetInnerHTML={{ __html: message }} />
          ) : null}
        </Col>
        {!loading &&
        state?.selectedDomain.length > 0 &&
        Object.keys(filteredDashboardDetails)?.length === 0 ? (
          <ColsEnd md={6}>
            <StyledPrimaryBtn
              text="Load Data"
              height="38px"
              onClick={handleClickLoadData}
              disabled={!state?.selectedPassingYear?.year}
              disabledStyle={!state?.selectedPassingYear?.year}
            />
          </ColsEnd>
        ) : null}
      </Row>
    </>
  )
}
